import type { PmsAccountRef } from './pmsAccount';

/**
 * DV-3382: the `{entity}` segment of property-service's
 * `/properties/pms/{entity}/…` routes is the account's entityId, not its name.
 *
 * A name can contain `/` ("East/South Bay", "RE/MAX"). Encoded as `%2F`,
 * Tomcat rejects the request with a 400 before property-service sees it, and
 * the rejection lands on the CORS preflight, so the integration silently never
 * connects. property-service resolves the id back to the name.
 *
 * DV-3345: pure. The caller names the account; this module never reads the
 * session (see pmsAccount.ts).
 */
export const pmsEntityPath = (account: PmsAccountRef): string =>
  `/property-service/api/v1/properties/pms/${encodeURIComponent(account)}`;
